import { useIntParam } from 'hooks';
import { useDispatch } from 'react-redux';
import { speakingSessionStore } from 'store';

export const useSpeakingSlots = () => {
  const speakingSessionId = useIntParam('sessionId');
  const dispatch = useDispatch();
  const { data: speakingSessionRooms, isLoading: isSpeakingSlotsLoading } =
    speakingSessionStore.service.speakingSessionApi.useGetSpeakingSessionRoomsQuery({
      speakingSessionId,
    });

  const { data: roomsEvents, isLoading: isRoomsEventsLoading } =
    speakingSessionStore.service.speakingSessionApi.useGetRoomsEventsQuery({
      speakingSessionId,
    });

  const anyRoomsAvailable = (speakingSessionRooms ?? []).length > 0;
  if (!anyRoomsAvailable) {
    dispatch(speakingSessionStore.actions.setRoomSlotCounts([]));
  }

  return {
    speakingSessionRooms: speakingSessionRooms ?? [],
    roomsEvents: roomsEvents ?? [],
    isLoading: isSpeakingSlotsLoading || isRoomsEventsLoading,
    anyRoomsAvailable: anyRoomsAvailable,
  };
};
